import { render, staticRenderFns } from "./SongCard.vue?vue&type=template&id=e1f87e1e"
import script from "./SongCard.vue?vue&type=script&lang=js"
export * from "./SongCard.vue?vue&type=script&lang=js"
import style0 from "./SongCard.vue?vue&type=style&index=0&id=e1f87e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports